<template lang="pug">
.fincancial-detail-item
  .info 
    slot(name="item" v-if="!itemValue")
    .value  {{ itemValue }} 
    .description {{ description }}
</template>

<script lang="ts">
export default {
  props: {
    itemValue: {
      type: Number,
    },
    description: {
      type: String,
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.fincancial-detail-item {
  display: flex;
  flex: 1;
  min-height: 9rem;

  &:before {
    content: "";
    width: 0.25rem;
    height: 100%;
    background-color: $primary-color;
  }

  &:nth-child(even) {
    &:before {
      background-color: $secondary-color;
    }
  }

  .info {
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 0.75rem;
    background-color: $background-color-default;
    border: $bar-border;
    .value {
      font-size: 1.75rem;
      font-weight: 700;
      color: $font-color-default;
    }

    .description {
      color: $font-color-secondary;
      max-width: 13rem;
    }
  }
}
</style>
